module.exports = __webpack_public_path__ + "static/media/packageDelivery.3dba4b4e.svg";